module.exports = "<div class=\"map-component\" id=\"map\"> \r\n\r\n    \r\n    <div id=\"popup\"></div> \r\n\r\n\r\n\r\n</div>\r\n\r\n"